import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgError = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M8.98885 1.0002C6.85125 1.03519 4.81329 1.91001 3.31552 3.43553C2.5661 4.18165 1.97481 5.07121 1.577 6.05103C1.17918 7.03086 0.982999 8.08083 1.00018 9.1382C0.998955 10.1714 1.20163 11.1947 1.59659 12.1494C1.99154 13.1041 2.57103 13.9715 3.30182 14.7019C4.03261 15.4322 4.90035 16.0112 5.85531 16.4056C6.81026 16.8 7.83366 17.002 8.86685 17.0002H9.00952C11.1478 16.9782 13.19 16.1089 14.688 14.5829C16.1861 13.057 17.0176 10.9992 17.0002 8.86086C17.0026 7.81514 16.796 6.77948 16.3924 5.81479C15.9887 4.8501 15.3963 3.97586 14.6499 3.24347C13.9034 2.51108 13.0181 1.93534 12.0459 1.55009C11.0737 1.16485 10.0343 0.977888 8.98885 1.0002ZM8.00019 12.0282C7.99538 11.8975 8.01668 11.7671 8.06285 11.6447C8.10902 11.5223 8.17913 11.4104 8.26907 11.3154C8.35902 11.2204 8.467 11.1444 8.58669 11.0916C8.70639 11.0389 8.8354 11.0105 8.96619 11.0082H8.98419C9.24726 11.0087 9.49992 11.111 9.68921 11.2937C9.87849 11.4764 9.9897 11.7253 9.99952 11.9882C10.0044 12.1189 9.98318 12.2493 9.93704 12.3718C9.8909 12.4942 9.8208 12.6062 9.73084 12.7012C9.64088 12.7962 9.53286 12.8722 9.41313 12.925C9.29339 12.9777 9.16433 13.006 9.03352 13.0082H9.01552C8.75255 13.0074 8.50007 12.9049 8.31086 12.7223C8.12164 12.5397 8.01033 12.291 8.00019 12.0282ZM8.33352 9.33353V5.33353C8.33352 5.15672 8.40376 4.98715 8.52878 4.86213C8.65381 4.7371 8.82338 4.66686 9.00019 4.66686C9.177 4.66686 9.34657 4.7371 9.47159 4.86213C9.59661 4.98715 9.66685 5.15672 9.66685 5.33353V9.33353C9.66685 9.51034 9.59661 9.67991 9.47159 9.80493C9.34657 9.92996 9.177 10.0002 9.00019 10.0002C8.82338 10.0002 8.65381 9.92996 8.52878 9.80493C8.40376 9.67991 8.33352 9.51034 8.33352 9.33353Z",
			fill: "#D9DEEB"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white",
			transform: "translate(1 1)"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgError);
export default ForwardRef;
